export default "__VITE_ASSET__fPSpwmF7__"